import httpClient from '../httpClient';

const getAll = async () => {
  return await httpClient.get(`/level/?sort=name`);
};

export {
  getAll,
};